import { OfficialAccountVerifyStatus } from '@/hooks';

export const getOfficialPath = (official: OfficialAccount) => {
  if (official?.verify_status === OfficialAccountVerifyStatus.VERIFIED) {
    return `/official/${official?.slug || official.id}`;
  } else {
    return `/official/${official?.id || ''}`;
  }
};
